module.exports = __webpack_public_path__ + "img/maas_wrapbg11.04015742.png";